import { useCallback, useEffect, useRef, useState } from 'react'

import { getPartLengthInBars, getPartOffsetInBars } from '../../../utils/progUtils'
import { Prog } from '../../../utils/types'
import Player from '../../editor/hooks/player/Player'

type Props = { prog: Prog; currentPartId: number; player: Player; looped?: boolean }

const usePlaybackPosition = ({ prog, currentPartId, player, looped }: Props) => {
  const requestPosition = useCallback(() => {
    const partLength = getPartLengthInBars(prog, currentPartId)
    const barsOffset = getPartOffsetInBars(prog, currentPartId)
    const position = player.getTransportPosition(looped ? 0 : barsOffset)
    return {
      time: 1 + (position % partLength),
      loop: Math.ceil(position / partLength),
      partDuration: partLength,
      currentPart: currentPartId,
    }
  }, [prog, currentPartId])

  const [val, setVal] = useState(requestPosition())
  const requestRef = useRef<number>()

  const animate = () => {
    setVal(requestPosition())
    requestRef.current = requestAnimationFrame(animate)
  }

  useEffect(() => {
    setVal(requestPosition())
    requestRef.current = requestAnimationFrame(animate)
    return () => {
      if (requestRef.current === undefined) {
        return
      }
      cancelAnimationFrame(requestRef.current)
    }
  }, [prog, currentPartId || null])
  return val
}

export default usePlaybackPosition
